import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DeviceSnapshotIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 21.6004L20.3138 16.8004V7.20039L12 2.40039L3.68616 7.20039V16.8004L12 21.6004ZM12 21.6004V12.6004M12 12.6004L4.2 7.80039M12 12.6004L19.8 7.80039"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

DeviceSnapshotIcon.displayName = 'DeviceSnapshotIcon';
